export default __webpack_public_path__ + "static/media/newsImage.10443b9f.jpg";